<template>
    <div class="d-flex flex-column">
        <h2 class="p-3 border-bottom-light">Company Settings</h2>

        <div class="text-center mt-4" v-if="loadingSettings">
            <loader></loader>
        </div>

        <div v-else class="content">
            <tabs>
                <tab name="PROFILE">
                    <tabCompany
                        :company="companySettings"
                        @save="saveSettings"
                        @dirty-changed="onTabCompanyDirtyChanged"
                    ></tabCompany>
                </tab>
                <tab name="PRESETS">
                    <tabPresets
                        ref="tabPresets"
                        :presets="companySettings.settingsPresets"
                        @update:presets="companySettings.settingsPresets = $event"
                        @dirty-changed="onTabPresetsDirtyChanged"
                        @save="saveSettings"
                    ></tabPresets>
                </tab>
                <tab name="BOOKING WIDGET">
                    <tabWidget @save="saveSettings"></tabWidget>
                </tab>
                <tab name="INTEGRATIONS">
                    <tabIntegrations :presets="companySettings.settingsPresets" @save="saveSettings"></tabIntegrations>
                </tab>
                <tab name="ACCOUNTS">
                    <tabAccounts></tabAccounts>
                </tab>
                <tab name="SEGMENTATION">
                    <tabSalesChannels></tabSalesChannels>
                </tab>
                <tab name="MY PLAN">
                    <tabPlan></tabPlan>
                </tab>
            </tabs>
        </div>
    </div>
    </template>

    <script>
    import { mapGetters, mapActions } from 'vuex'
    
    import extendedVSelect from '@/extends/vue-select'
    import Loader from '@/tools/loaders/loader1'
    import tabCompany from './TabCompany'
    import tabPresets from './TabPresets'
    import tabInvoices from './TabInvoices'
    import tabPaymentMehtod from './TabPaymentMehtod'
    import tabTicket from './TabTicket'
    import tabAccounts from './TabAccounts'
    import tabWidget from './TabWidget'
    import tabIntegrations from './TabIntegrations'
    import tabSalesChannels from './TabSalesChannels'
    import tabPlan from './TabPlan'

    export default {
        beforeMount() {
            this.downloadSupplierIntegrations();
        },
        data() {
            return {
                hasUnsavedChanges: false,
            };
        },
        computed:{
            ...mapGetters([
                'getCompanyInfo',
                'getCompanySettings',
                'getIsDonwloadingCompanySettings'
            ]),
            companySettingsOld() {
                return this.getCompanyInfo;
            },
            companySettings() {
                return this.getCompanySettings;
            },
            loadingSettings() {
                return this.getIsDonwloadingCompanySettings || !this.companySettings.id;
            }
        },
        methods:{
            ...mapActions([
                'initCompany',
                'updateCompany',
                'downloadSupplierIntegrations'
            ]),
            saveSettings() {
                this.updateCompany(this.companySettingsOld);
            },
            handleBeforeUnload(e) {
                if (this.hasUnsavedChanges) {
                    e.preventDefault();
                    e.returnValue = '';
                }
            },
            onTabCompanyDirtyChanged(isDirty) {
                this.hasUnsavedChanges = isDirty;
            },
            onTabPresetsDirtyChanged(isDirty) {
                this.hasUnsavedChanges = isDirty;
            },
        },
        beforeRouteLeave(to, from, next) {
            const message = `
                <div class="fs-larg font-weight-600 mb-4">Unsaved Changes</div>
                <div>Are you sure you want to leave? Any unsaved changes will be lost.</div>
            `;
            
            if (this.hasUnsavedChanges && to.name !== "auth.login") {
                this.$dialog.confirm(
                    message,
                    { okText: "Yes", cancelText: "Cancel" }
                )
                .then(() => {
                    this.$refs.tabPresets && this.$refs.tabPresets.reset();
                    next();
                })
                .catch(() => {
                    next(false);
                });
            } else {
                next();
            }
        },
        components:{
            vSelect: extendedVSelect,
            tabCompany,
            tabPresets,
            tabInvoices,
            tabPaymentMehtod,
            tabTicket,
            tabAccounts,
            tabWidget,
            tabIntegrations,
            tabSalesChannels,
            tabPlan,
            Loader
        }
    }
    </script>

    <style lang="scss" scoped>
        .yScroll {
            overflow-y: auto;
        }
    </style>



// WEBPACK FOOTER //
// Settings.vue?7f3ee989